<template>
	<span v-bind:class="{ selected: value }" @click="click">
		<el-checkbox v-model="value"></el-checkbox> 
	</span>
</template>
<script>
export default {
	name: 'patient-list-select',

	props: ['value'],

	methods: {
		click(e) {
			e.stopPropagation()
			e.preventDefault()
			this.$emit('input', ! this.value)
		}
	}
}
</script>
<style lang="scss" scoped>
span {
	padding: 10px;
}
</style>
